export default {
	name: "customer-pricing-per-Zone",
	data() {
		return {
			customerPricing: [],
			customerPricingHeadings: [
				{
					text: "Product",
					field: "product"
				},

				{
					text: "Customer",
					field: "customer"
				},
				{
					text: "Zone",
					field: "zone"
				},
				{
					text: "Base Price",
					field: "priceAsString"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Price After Discount",
					field: "discountedPriceAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			products: [],
			zones: [],
			customers: [],
			productTypes: [],
			productType: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			productAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditProductModal",
				heading: "Add Product",
				product: {
					productId: null,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					price: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					erpCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					allowCollection: false,
					allowDelivery: false,
					allowCollectionDeliveryErrorMessage: null,
					allowCollectionDeliveryHasError: false
				},
				isUpdate: false
			},
			productMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markProductAsActiveInactiveModal",
				heading: "Mark Product As Active/Inactive",
				isActive: null,
				customerPricingId: null
			},
			filterStateChanged: false,
			filter:{
				zoneId: null,
				customerId: null,
				productId: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomerPricing(){
			this.loading = true;
			let request = {
				zoneId: this.filter.zoneId === null ? 0 : this.filter.zoneId,
				productId: this.filter.productId === null ? 0 : this.filter.productId,
				companyId: this.filter.customerId === null ? 0 : this.filter.customerId,
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				orderTypeId: orderHelper.orderType.exTank,
			};
			productService.getCompanyShippingAddressPrices(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customerPricing = successResponse.data.result;
						for(let i = 0; i < this.customerPricing.length; i++){
							this.customerPricing[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.customerPricing[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								}
							];
							this.customerPricing[i].priceAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.customerPricing[i].basePrice);
							this.customerPricing[i].discountAmountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.customerPricing[i].discountAmount);
							this.customerPricing[i].discountedPriceAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.customerPricing[i].priceAfterDiscount);
						}
						this.customerPricing = dataTableHelper.castFieldValues(this.customerPricing);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProducts(){
			this.loading = true;
			let request = {
				isActive: true,
				allowExTank: true
			};
			productService.getProducts(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.products.unshift(
							{
								productId: 0,
								name: "All"
							});
						this.products = $.map(this.products,
							function (obj) {
								obj.id = obj.id || obj.productId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.filter.productId = 0;
						if(this.customers.length > 0 && this.zones.length > 0 && this.products.length > 0){
							this.getCustomerPricing()
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getZones() {
			this.loading = true;
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				}
			];
			let activeOnly = true;
			systemService.getZones(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.zones = successResponse.data.result;
						this.zones = dataTableHelper.castFieldValues(this.zones);
						this.zones.unshift(
							{
								zoneId: 0,
								description: "All"
							});
						this.zones = $.map(this.zones,
							function (obj) {
								obj.id = obj.id || obj.zoneId;
								obj.text = obj.text || obj.description;
								return obj;
							});
						this.filter.zoneId = 0;
						if(this.customers.length > 0 && this.zones.length > 0 && this.products.length > 0){
							this.getCustomerPricing()
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompanies(){
			this.loading = true;
			let request = {
				isActive: true,
				pageNumber: 1,
				pageSize: 5000,
				isExTankCompany: true,
			};
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.customers = successResponse.data.result;
						this.customers.unshift({
								companyId: 0,
								registeredCompanyName: "All"
						});
						this.customers = $.map(this.customers,
							function (obj) {
								obj.id = obj.id || obj.companyId;
								obj.text = obj.text || obj.registeredCompanyName;
								return obj;
							});
						this.filter.customerId = this.customers[0].companyId;
						if(this.customers.length > 0 && this.zones.length > 0 && this.products.length > 0){
							this.getCustomerPricing()
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getCustomerPricing();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onZoneFilterSelect(zone){
			if(this.filter.zoneId !== zone.id){
				this.filter.zoneId = zone.id;
				this.filterStateChanged = true;
			}
		},
		onCustomerFilterSelect(customer){
			if(this.filter.customerId !== customer.id){
				this.filter.customerId = customer.id;
				this.filterStateChanged = true;
			}
		},
		onProductFilterSelect(product){
			if(this.filter.productId !== product.id){
				this.filter.productId = product.id;
				this.filterStateChanged = true;
			}
		},
		onPricingActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.$router.push("/pricing/extank/editCustomerGroupPricingForZone/" + actionAndData.data.productId + "/" + actionAndData.data.companyId)
					break;
				case this.actionKeys.markAsActiveInactive:
					this.productMarkAsActiveInactiveModal.showModal = true;
					this.productMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.productMarkAsActiveInactiveModal.heading = "Mark Customer Group Pricing As " + (this.productMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.customer + " and product " + actionAndData.data.product;
					this.productMarkAsActiveInactiveModal.productId = actionAndData.data.productId;
					this.productMarkAsActiveInactiveModal.customerPricingId = actionAndData.data.companyShippingAddressPriceId;
					break;
			}
		},
		onMarkProductActiveInactiveSelected(isActive){
			this.productMarkAsActiveInactiveModal.isActive = isActive;
			console.log("productMarkAsActiveInactiveModal.isActive", this.productMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.productMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				companyShippingAddressPriceId: this.productMarkAsActiveInactiveModal.customerPricingId,
				isActive: markAsActive
			};
			productService.markCompanyShippingAddressPriceAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getCustomerPricing();
						this.productMarkAsActiveInactiveModal.showModal = false;
						this.productMarkAsActiveInactiveModal.isActive = null;
						this.productMarkAsActiveInactiveModal.productId = null;
					}
					this.productMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.productMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Customer Group Pricing For Zone");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Ex-Tank"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Customer Group Pricing For Zone"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getZones();
		this.getCompanies();
		this.getProducts();
		this.setBreadcrumbs();
	}
};